import { Timestamp } from 'firebase/firestore'
import { create } from 'zustand'
import Database from '../types/Database'

export type EnrichedInvite = Database.Invite & {
  diveSiteName: string
  diveDateTime: Timestamp
  hostDisplayName: string
  distanceKm: number | null
}

interface InviteStoreState {
  invites: EnrichedInvite[]
  isLoading: boolean
  error: string | null
  setInvites: (invites: EnrichedInvite[]) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  clear: () => void
}

export const useInviteStore = create<InviteStoreState>(set => ({
  invites: [],
  isLoading: false,
  error: null,
  setInvites: invites => set({ invites }),
  setLoading: loading => set({ isLoading: loading }),
  setError: error => set({ error }),
  clear: () => set({ invites: [], isLoading: false, error: null })
}))
